import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconOverwriteEmpty = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	fillRule: "evenodd",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeMiterlimit: 1.4,
	clipRule: "evenodd",
	viewBox: "92 92 840 840",
	width: "1em",
	height: "1em",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			d: "M0 0h1024v1024H0z"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 14584.8,
			cy: 3131.04,
			r: 319.213,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 61,
			transform: "matrix(-1 0 0 1 15100.2 -2593.16)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 61,
			d: "M787.2 677.51C714.7 559.37 635 441.4 593.9 424.86c-63.9-25.74 28.8 270.6-84 277.84-87 5.58-184.6-140.7-265-294.38"
		})
	]
});
export default SvgIconOverwriteEmpty;
